export const HEARTBEAT_INTERVAL_MS = 30000
export const HEARTBEAT_MIN_GAP_MS = 8000

export function nextHeartbeatDelay(status, attempt) {
  if (status === 401 || status === 403) return null
  if (!status) return HEARTBEAT_INTERVAL_MS
  const step = Math.max(0, Number(attempt) || 0)
  return Math.min(HEARTBEAT_INTERVAL_MS * (2 ** Math.min(step, 3)), 120000)
}
